import type {
  LegislativeStatusPublicGetAllResponse,
  LegislativeTypePublicGetAllResponse,
  MeetingBodyGetAllResponse,
  PublicGovernmentResponse,
} from '@govinity/validation/public';
import { create } from 'zustand';

interface GovernmentProperties {
  government: PublicGovernmentResponse | null;
  legislativeTypes: LegislativeTypePublicGetAllResponse[];
  legislativeStatuses: LegislativeStatusPublicGetAllResponse[];
  meetingBodies: MeetingBodyGetAllResponse[];
  meetingsCacheKey: number;
}

interface GovernmentState extends GovernmentProperties {
  setGovernment: (government: PublicGovernmentResponse | null) => void;
  setLegislativeTypes: (legislativeTypes: LegislativeTypePublicGetAllResponse[]) => void;
  setLegislativeStatuses: (legislativeStatuses: LegislativeStatusPublicGetAllResponse[]) => void;
  setMeetingBodies: (meetingBodies: MeetingBodyGetAllResponse[]) => void;
  invalidateMeetingsCache: () => void;
}

const initialProperties: GovernmentProperties = {
  government: null,
  legislativeTypes: [],
  legislativeStatuses: [],
  meetingBodies: [],
  meetingsCacheKey: 0,
};

export const useGovernmentStore = create<GovernmentState>((set) => ({
  ...initialProperties,
  setGovernment: (government) => set({ government }),
  setLegislativeTypes: (legislativeTypes) => set({ legislativeTypes }),
  setLegislativeStatuses: (legislativeStatuses) => set({ legislativeStatuses }),
  setMeetingBodies: (meetingBodies) => set({ meetingBodies }),
  reset: () => set({ ...initialProperties }),
  invalidateMeetingsCache: () => set((state) => ({ meetingsCacheKey: state.meetingsCacheKey + 1 })),
}));
